import { getGetDocumentQueryKey } from '@modusign/openapi-client-external-document';
import { useQueryClient } from 'react-query';
import { useToggle } from 'react-use';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';

import { ExternalDocument } from '../../../types/ExternalDocument';
import ParticipantsViewer from '../../ParticipantsViewer';
import Editor from './Editor';

interface ParticipantsPanelProps {
  externalDocument: ExternalDocument;
  onIsDirtyChange: (isDirty: boolean) => void;
}

export default function ParticipantsPanel({
  externalDocument,
  onIsDirtyChange,
}: ParticipantsPanelProps) {
  const workspaceId = useWorkspaceId();

  const [isEditing, toggleEditing] = useToggle(false);
  const queryClient = useQueryClient();

  if (isEditing) {
    return (
      <Editor
        externalDocument={externalDocument}
        onCancel={() => {
          onIsDirtyChange(false);
          toggleEditing();
        }}
        onIsDirtyChange={onIsDirtyChange}
        onSuccess={() => {
          onIsDirtyChange(false);
          toggleEditing();
          queryClient.invalidateQueries(getGetDocumentQueryKey(workspaceId, externalDocument.id));
        }}
      />
    );
  }

  return (
    <ParticipantsViewer
      externalDocumentId={externalDocument.id}
      participants={externalDocument.signers}
      onClickEdit={toggleEditing}
    />
  );
}
